<template>
<div id="app">
    <MainNavbar/>
     <router-view/>
</div>
</template>

<script>
import MainNavbar from "./components/shared/MainNavbar";
export default {
    name: "app",
    components: {
        MainNavbar
    },
    methods: {
    },
    data() {
        return {
            
        };
    }
};
</script>
